import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { EntityService } from "../services/entity-service";

export function RLLovFilter(): ng.IDirective {
    return {
        restrict: 'E',
        bindToController: true,
        controllerAs: 'lfVM',
        controller: RLLovFilterController,
        template: require("/assets/app/templates/lov-filter.html"),
        scope: {
            lovMetaDatas: '=',
            selectedPaths: '='
        }
    }
}

class RLLovFilterController {
    static $inject = ['$scope', 'entityService'];

    lovMetaDatas: Models.ICharacteristicMetaData[];
    lovs: { [label: string]: Models.ICharLovMetaData } = {};
    lovFilter: { [label: string]: string } = {};
    orderedCMDs: string[] = [];
    selectedPaths: { [label: string]: any[] } = {};
    selectedLovIDs: { [label: string]: number[] } = {};

    constructor(private $scope: ng.IScope, private entityService: EntityService) {
        $scope.$watch(() => this.lovMetaDatas, (newValue) => {
            if (!_.isEmpty(this.lovMetaDatas)) {
                _.sortBy(this.lovMetaDatas, (cmd) => {
                    return cmd.sequenceNumber;
                }).forEach((cmd) => {
                    this.orderedCMDs.push(cmd.label);
                    this.loadMetaDataLOVs(cmd);
                });
            }
        }, true);
    }

    // only going to do hierarchical lists for now
    private loadMetaDataLOVs(cmd: Models.ICharacteristicMetaData) {
        if (cmd.charValueSourceID && cmd.charValueSetID && !this.lovs[cmd.label]) {
            this.entityService.getCharLovMetaData(cmd.charValueSourceID, cmd.charValueSetID)
                .then((result2) => {
                    if (_.any(result2.listOfValues, (lov) => {
                        return lov.childValues.length > 0;
                    })) {
                        this.lovs[cmd.label] = result2;
                    } else {
                        _.remove(this.orderedCMDs, (label) => {
                            return label == cmd.label;
                        });
                    }
                });
        }
    }

    public GroupChanged(label: string, group: Models.ICharacteristicValueGroup) {
        var newValueIDs: number[] = [];
        if (group != null) {
            newValueIDs = group.charValueAssociations.map(cva => cva.charValueID);
        }

        while (this.selectedLovIDs[label].pop()) {

        }

        this.selectedLovIDs[label] = this.selectedLovIDs[label].concat(newValueIDs);

        this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
    }
}
